import { __extends } from "tslib";
import { deserializeAws_json1_1StartDeliveryStreamEncryptionCommand, serializeAws_json1_1StartDeliveryStreamEncryptionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartDeliveryStreamEncryptionCommand = /** @class */ (function (_super) {
    __extends(StartDeliveryStreamEncryptionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartDeliveryStreamEncryptionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartDeliveryStreamEncryptionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartDeliveryStreamEncryptionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartDeliveryStreamEncryptionCommand(input, context);
    };
    StartDeliveryStreamEncryptionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartDeliveryStreamEncryptionCommand(output, context);
    };
    return StartDeliveryStreamEncryptionCommand;
}($Command));
export { StartDeliveryStreamEncryptionCommand };
//# sourceMappingURL=StartDeliveryStreamEncryptionCommand.js.map